module.exports = __webpack_public_path__ + "static/media/img_notices_demo.00f23c64.png";